import { useDispatch } from "react-redux";
import { setSendData } from "../../../Store/Slice/scheduleSlice";

const useSetLineItems = () => {
  const dispatch = useDispatch();
  const set = (lineItems, totalVehicles) => {
    const newArr = lineItems?.map((item) => {
      return {
        product_service_id: item?.type_of_service?.id,
        qty: item?.quantity,
        technician_cost: item?.type_of_service?.technician_cost,
        time: item?.approximate_time,
        price: item?.price,
      };
    });
    dispatch(setSendData({ job_items: newArr, vehicle_count: totalVehicles }));
  };

  const clear = () => {
    dispatch(setSendData({ job_items: null }));
  };

  return {
    set,
    clear,
  };
};

export default useSetLineItems;
